import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import MandatoryIconField from 'Components/MandatoryIconField';

const ItemsYearReplicate = ({
    onUpdateShowItemsYearReplicate,
    onUpdateReloadItemCost,
    showItemsYearReplicate
}) => {
    const [yearSource, setYearSource] = useState(null);
    const [yearDestination, setYearDestination] = useState(null);

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    async function postReplicateItemsYear() {
        const response = await ExecuteAxios.api('post', `/item-cost/replicate-year/`, {
            yearPaste: yearDestination.getFullYear(),
            yearCopy: yearSource.getFullYear()
        })

        if (response) {
            onUpdateShowItemsYearReplicate(false);
            onUpdateReloadItemCost(true)
        }
        return response;
    }

    return (
        <MiddlePanel isVisible={showItemsYearReplicate}>
            <Panel style={{
                width: '100%',
                height: '100%',
                padding: '5px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <Panel titlePage={'Replicar ano'}
                    style={panelListStyle}
                    canViewCRUD={true}
                    setInserting={true}
                    postFunction={postReplicateItemsYear}
                    canSaveAfterNewRecord={yearSource && yearDestination}
                    enableEdit={false}
                    canEdit={false}
                    enableDelete={false}
                    insertNameButton={'Replicar'}
                    cancelFunction={() => { onUpdateShowItemsYearReplicate(false) }}
                    cancelNameButton='Fechar'
                    canDelete={false}
                    inserting={true}
                    updating={false}
                >
                    <div style={{ display: 'flex', flexDirection: 'row', padding: '10px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', margin: '0px 10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <label>Ano de origem</label>
                                <MandatoryIconField />
                            </div>
                            <ReactDataPickerComp
                                selected={yearSource}
                                onChange={(date) => { setYearSource(date) }}
                                wrapperClassName={'width-full'}
                                className='validate-attribute-without-width cursor-pointer'
                                showYearPicker={true}
                                dateFormat={'yyyy'}
                                setter={setYearSource}
                            />


                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', margin: '0px 10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <label>Ano de destino</label>
                                <MandatoryIconField />
                            </div>
                            <ReactDataPickerComp
                                selected={yearDestination}
                                onChange={(date) => { setYearDestination(date) }}
                                wrapperClassName={'width-full'}
                                className='validate-attribute-without-width cursor-pointer'
                                showYearPicker={true}
                                dateFormat={'yyyy'}
                                setter={setYearDestination}
                            />
                        </div>
                    </div>
                </Panel>
            </Panel>
        </MiddlePanel>
    );
}

export default ItemsYearReplicate;
